import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Wanna Contact Me?`}</p>
    <p>{`Mail me at `}<a parentName="p" {...{
        "href": "mailto:prajjwal.coep@gmail.com"
      }}>{`prajjwal.coep@gmail.com`}</a></p>
    <p>{`Reach me on :
`}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/prajjwal-datir-coep/?originalSubdomain=in"
      }}>{`LinkedIn`}</a></p>
    <p>{`Stalk me on:
`}<a parentName="p" {...{
        "href": "http://github.com/prajjwaldatir"
      }}>{`GitHub`}</a></p>
    <h2>{`Thanks!`}</h2>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      